import React from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplayEtfPerformance } from "../../../data/reports/securityStatistics/hooks/useDisplayEtfPerformance";

export interface DisplayEtfPerformanceProps {
  symbol?: string;
}

export const DisplayEtfPerformance: React.FunctionComponent<DisplayEtfPerformanceProps> = ({
  symbol,
}) => {
  const etfPerformance = useDisplayEtfPerformance(symbol);
  const style = useDisplaySingleEmementStyles();

  const { getPercentStringDynamic4 } = React.useContext(LocalizationContext);
  const [auth] = useAuth();

  const formatShare = (v?: number) =>
    getPercentStringDynamic4(v !== undefined && v !== null ? v * 100 : undefined, true);

  const formatCategory = (v?: number) =>
    getPercentStringDynamic4(v, true);

  return (
    <div className={style.root}>
      {etfPerformance?.rows?.map((row) => (
        <div key={row.period} className={`${style.row} ${style.rowBorder}`}>
          <span className={style.label}>{row.period}</span>
          <span className={style.value} style={{ whiteSpace: "pre-line" }}>
            {`Klasa fonda: ${formatShare(row.shareClassReturn)}\nKategorija: ${formatCategory(row.categoryReturn)}`}
          </span>
        </div>
      ))}
    </div>
  );
};